export default {
    PENDING: 'Pendente',
    OVERDUE: 'Vencida',
    CONFIRMED: 'Pago',
    RECEIVED: 'Recebida',
    REFUNDED: 'Estornada',
    RECEIVED_IN_CASH: 'Pago em dinheiro',
    REFUND_REQUESTED: 'Estorno solicitado',
    CHARGEBACK_REQUESTED: 'Recebido chargeback',
    CHARGEBACK_DISPUTE: 'Em disputa de chargeback',
    AWAITING_CHARGEBACK_REVERSAL: 'Disputa vencida',
    DUNNING_REQUESTED: 'Em processo de recuperação',
    DUNNING_RECEIVED: 'Recuperada',
    AWAITING_RISK_ANALYSIS: 'Pagamento em análise'
}
